module.exports = new __parcel__URL__("coins.c8a25781.svg").toString();